import React, { CSSProperties } from 'react';
import cn from 'classnames';
import Link from '@base/lib/ThemeLink';
import Iconfont from '@base/lib/Iconfont';
import { useStoreState } from 'base/store';
import { getTopPromotionBarStyles } from 'base/utils/features';
import styles from './index.module.less';
import { ITopPromotionBar } from 'base/interfacesV2/feature';
import { ThemeSwiper } from '@base/lib/ThemeSwiper';

type ListItemListItemProps = {
    textStyle: CSSProperties;
    item: ITopPromotionBar['banner'][number];
}

const ListItem: React.FC<ListItemListItemProps> = props => {
    const { textStyle, item } = props;
    return (
        <div className={styles.item}>
            {item.bannerUrl ? (
                <Link href={item.bannerUrl}>
                    <a style={textStyle} className={styles['text-wrap']}>
                        <Iconfont className={item.iconClassName}/>
                        {item.bannerText}
                    </a>
                </Link>

            ) : (
                <span style={textStyle} className={styles['text-wrap']}>
                    <Iconfont className={item.iconClassName}/>
                    {item.bannerText}
                </span>
            )}
        </div>
    )
}

const TopPromotionBar: React.FC = () => {
    const { topPromotionBar: config } = useStoreState('persistStore');
    if (!config || !config.banner.length) {
        return null;
    }
    const { bgStyle, textStyle } = getTopPromotionBarStyles(config);
    const { banner: list } = config;

    return (
        <>
            <div className={styles.list} style={bgStyle}>
                <div className="flex wrapper-large">
                    {list.map(item => (
                        <ListItem
                            key={item.bannerText}
                            textStyle={textStyle}
                            item={item}
                        />
                    ))}
                </div>
            </div>

            <ThemeSwiper
                className={cn(styles.swiper, styles['pc-swiper'])}
                style={bgStyle}
                direction="vertical"
                loop
                autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                }}
                list={list}
                render={item => (
                    <ListItem
                        textStyle={textStyle}
                        item={item}
                    />
                )}
            />

        </>
    )
};

export default TopPromotionBar;